export const background = require("./images/background_transparent.png")
//export const background = require("./images/background.png")

export const sotsGameplay = require('./videos/sots_gameplay.mp4')
export const sotsWizards = require('./videos/sots_wizards.mp4')
export const sotsShield = require('./videos/sots_shield.mp4')
export const sotsTank = require('./videos/sots_tank.mp4')
export const sotsAbility = require('./images/sots_ability.png')
export const sotsBoss = require('./images/sots_boss.jpg')
export const sotsDialogue = require('./images/sots_dialogue.png')

export const zcGameplay = require('./videos/zc_gameplay.mp4')
export const zcMinigame = require('./videos/zc_minigame.mp4')
export const zcStory = require('./images/zc_story.png')

export const harCreation = require('./videos/har_creation.mp4')
export const harFkIk = require('./videos/har_fk_ik.mp4')
export const harPanel = require('./images/har_panel.png')

export const effectHeart = require('./images/effect_screenshot.png')
export const monkeyStyled = require('./images/monkey_styled.png')
export const mcHouse = require('./images/mc_screenshot.png')
export const csgoModels = require('./images/csgo_screenshot.png')

export const cmCrowdTest = require('./videos/cm_crowdTest.mp4')
export const homeBackground = require('./videos/home_backgroundVideo.mp4')

export const musSomeBossaNova = require('./music/some_bossa_nova.mp3')
export const sbnProjectFile = require('./images/sbn_projectFile.png')

export const ss_preview = require('./videos/ss_preview.mp4')
export const ss_nodeGroup = require('./images/ss_nodeGroup.png')
export const cg_normalDog = require('./videos/cg_normaldog.mp4')
export const cg_potion = require('./videos/cg_potion.mp4')

export const bc_gameplay = require('./videos/bc_gameplay.mp4')
export const bc_shop = require('./images/bc_shop.png')

export const td_preview = require('./images/td_preview.png')

export const storify_contribute = require('./videos/storify_contribute.mp4')
export const storify_rating = require("./videos/storify_rating.mp4")
export const storify_account = require('./videos/storify_account_create.mp4')
export const storify_erd = require('./images/storify_erd.png')

export const roam_drawing = require('./videos/roam_drawing_trim.mp4')
export const roam_electricity = require('./videos/roam_electricity_arcade_trim.mp4')
export const roam_instrument = require('./videos/roam_instrument_trim.mp4')
export const roam_submarine = require('./videos/roam_submarine2_trim.mp4')
export const roam_trash_clean = require('./videos/roam_trash_clean.mp4')
export const roam_water_pour = require('./videos/roam_waterpour_trim.mp4')
export const roam_map = require('./images/roam_map.png')
export const roam_achievements = require('./images/roam_achivements.png')

export const gomoku_play = require('./videos/gomoku_play.mp4')
export const gomoku_undo = require('./videos/gomoku_undo.mp4')
export const gomoku_banner = require('./images/gomoku_banner.png')
export const gomoku_uml = require('./images/gomoku_uml.png')

export const garden_banner = require('./images/garden_banner.png')
export const garden_showcase = require('./videos/garden_showcase.mp4')
export const garden_boing = require('./videos/garden_boing.mp4')
export const garden_towerplace = require('./videos/garden_towerplace.mp4')
export const garden_save = require('./videos/garden_savev2.mp4')
export const garden_prediction = require('./videos/garden_predictionv2.mp4')

export const portfolio_banner = require('./images/portfolio_cover.png')
export const portfolio_routing = require('./videos/portfolio_routing.mp4')
export const portfolio_lazy = require('./videos/portfolio_lazy.mp4')
export const portfolio_responsive = require('./videos/portfolio_responsive.mp4')

export const mangastone_banner = require('./images/mangastone_banner.png')
export const mangastone_scroll = require('./videos/mangastone_scroll.mp4')
export const mangastone_filter = require('./videos/mangastone_filter.mp4')




